module.exports = __webpack_public_path__ + "static/img/timg.bd0fa80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/timg.jpg
// module id = Vmam
// module chunks = 6